import React from 'react';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { IconButton } from '@rentspree/component-2023.components.atoms.icon-button';
import { Typography } from '@rentspree/component-2023.components.atoms.typography';

interface UnitCounterProps {
  label: string;
  count: number;
  onIncrement: () => void;
  onDecrement: () => void;
}

export const UnitCounter: React.FC<UnitCounterProps> = ({
  label,
  count,
  onIncrement,
  onDecrement,
}) => {
  return (
    <div style={{ width: '100%' }}>
      <Typography variant='body1' sx={{ fontWeight: '500', mb: 1 }}>
        {label}
      </Typography>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          backgroundColor: '#f5f5f5',
          borderRadius: '8px',
          padding: '8px 16px',
          height: '72px',
        }}
      >
        <IconButton
          onClick={onDecrement}
          disabled={count <= 0}
          aria-label={`decrease ${label}`}
        >
          <RemoveIcon />
        </IconButton>
        <Typography variant='h5' sx={{ fontWeight: '600' }}>
          {count}
        </Typography>
        <IconButton onClick={onIncrement} aria-label={`increase ${label}`}>
          <AddIcon />
        </IconButton>
      </div>
    </div>
  );
};
